import { Controller } from 'stimulus'

export default class extends Controller {
  select(event) {
    event.currentTarget.querySelector('input').click()
  }
}
